import axios from 'axios';
import { request_mutations, request_state } from '../utils/store';
import { TEAMS_LIST, TEAMS_DETAIL } from '../api';
import { auth } from '../utils/requests';

export default {
    namespaced: true,
    state: {
        list: request_state(),
        create: request_state(),
        update: request_state(),
        detail: request_state(),
        remove: request_state(),
    },
    mutations: {
        ...request_mutations('teams_list', 'list'),
        ...request_mutations('create_team', 'create'),
        ...request_mutations('update_team', 'update'),
        ...request_mutations('remove_team', 'remove'),
        ...request_mutations('detail_team', 'detail'),
    },
    actions: {
        list({ commit }, params) {
            commit('teams_list_loading');
            axios.get(TEAMS_LIST, { params, ...auth() })
                .then(response => commit('teams_list_success', response.data))
                .catch(error => commit('teams_list_error', error.response ? error.response.data : {}));
        },
        create({ commit }, data) {
            commit('create_team_loading');
            return new Promise((resolve) => {
                axios.post(TEAMS_LIST, data, auth()).then((response) => {
                    commit('create_team_success', response.data);
                    resolve();
                }).catch(error => commit('create_team_error', error.response ? error.response.data : {}));
            });
        },
        detail({ commit }, { team_id }) {
            commit('detail_team_loading');
            axios.get(TEAMS_DETAIL.replace('{id}', team_id), auth())
                .then(response => commit('detail_team_success', response.data))
                .catch(error => commit('detail_team_error', error.response ? error.response.data : {}));
        },
        update({ commit }, { team_id, data }) {
            commit('update_team_loading');
            return new Promise((resolve) => {
                axios.put(TEAMS_DETAIL.replace('{id}', team_id), data, auth()).then((response) => {
                    commit('update_team_success', response.data);
                    resolve();
                }).catch(error => commit('update_team_error', error.response ? error.response.data : {}));
            });
        },
        remove({ commit }, { team_id }) {
            commit('remove_team_loading');
            return new Promise((resolve) => {
                axios.delete(TEAMS_DETAIL.replace('{id}', team_id), auth()).then((response) => {
                    commit('remove_team_success', response.data);
                    resolve();
                }).catch(error => commit('remove_team_error', error.response ? error.response.data : {}));
            });
        },
    },
};
